import { type ElementType, type ReactNode } from 'react'
import { cn } from '@/lib/utils'

/** `both` fill keeps the element hidden through its `delay` instead of flashing in first. */
export function Appear({
  children,
  delay = 0,
  as,
  className,
}: {
  children: ReactNode
  delay?: number
  as?: ElementType
  className?: string
}) {
  const Comp = as ?? 'div'
  return (
    <Comp className={cn('animate-appear', className)} style={{ animationDelay: `${delay}ms` }}>
      {children}
    </Comp>
  )
}
